import React from "react"
import styled from "styled-components"
import OutsideClickHandler from "react-outside-click-handler"

const Menu = ({ children, active, close }) => {
  return (
    <OutsideClickHandler onOutsideClick={() => close()}>
      <Wrapper active={active}>
        <StyledMenu>
          {children.map((child, i) => (
            <MenuItem key={i}>{child}</MenuItem>
          ))}
        </StyledMenu>
      </Wrapper>
    </OutsideClickHandler>
  )
}

export default Menu

const Wrapper = styled.div`
  position: absolute;
  right: -10px;
  top: 100%;
  width: 100%;
  background-color: #fff;
  border: 1px solid #000;
  ${props => !props.active && "display: none;"}
`

const StyledMenu = styled.ul`
  list-style: none;
  padding-left: 0;
  margin: 0;
`

const MenuItem = styled.li`
  height: 60px;

  &:not(:last-child) {
    border-bottom: 1px solid #000;
  }

  &:hover {
    background-color: #eee;
  }
`
